import type { I18nFn } from '#/i18n/types/I18nFn';

export function ORG_FLAGGING_REASONS(i18n: I18nFn) {
  return [
    {
      id: 'MISSING_INFORMATION',
      description: i18n('Missing information'),
    },
    {
      id: 'THIS_IS_A_SCAM_SPAM',
      description: i18n('This is a scam/spam'),
    },
    {
      id: 'THIS_IS_ILLEGAL_INCITES_HATE',
      description: i18n('This is illegal/incites hate'),
    },
    {
      id: 'ORGANIZATION_POSTS_MANY_DUPLICATES',
      description: i18n('Organization posts many duplicates'),
    },
    {
      id: 'INFORMATION_IS_OUT_OF_DATE',
      description: i18n('Information is out of date'),
    },
    {
      id: 'WRONG_CATEGORY',
      description: i18n('Wrong category'),
    },
    {
      id: 'OTHER',
      description: i18n('Other'),
    },
  ];
}
